import React, { useState, useEffect, useRef } from 'react';
import './AudioWaves.css';

const AudioWaves = ({ stream, isRecording }: { stream: MediaStream, isRecording: boolean }) => {
  const [audioWaveVolumes, setAudioWaveVolumes] = useState<number[]>(Array(11).fill(5));
  const audioContextRef = useRef<AudioContext | null>(null);
  const analyserRef = useRef<AnalyserNode | null>(null);
  const dataArrayRef = useRef<Uint8Array | null>(null);
  const minVolume = 5;
  const maxVolume = 100;
  const updateInterval = 100;

  useEffect(() => {
    if (isRecording) {
      audioContextRef.current = new (window.AudioContext || (window as any).webkitAudioContext)();
      const source = audioContextRef.current.createMediaStreamSource(stream);
      analyserRef.current = audioContextRef.current.createAnalyser();
      source.connect(analyserRef.current);
      analyserRef.current.fftSize = 256;
      const bufferLength = analyserRef.current.frequencyBinCount;
      dataArrayRef.current = new Uint8Array(bufferLength);

      const getVolume = () => {
        if (analyserRef.current && dataArrayRef.current) {
          analyserRef.current.getByteFrequencyData(dataArrayRef.current);
          const sum = dataArrayRef.current.reduce((a, b) => a + b, 0);
          let average = sum / dataArrayRef.current.length;
          if (average < minVolume) average = minVolume;
          if (average > maxVolume) average = maxVolume;
          setAudioWaveVolumes(prev => {
            const newVolumes = [...prev];
            newVolumes.shift();
            newVolumes.push(average);
            return newVolumes;
          });
        }
      };

      const interval = setInterval(getVolume, updateInterval);
      return () => {
        clearInterval(interval);
        audioContextRef.current?.close();
      };
    } else {
      // Reset audio wave volumes
      setAudioWaveVolumes(Array(11).fill(5));
    }   
  }, [stream, isRecording]);

  return (
    <>
      {isRecording && audioWaveVolumes.map((waveVolume, i) => (
        <div key={i} className='audio-wave' style={{ height: `${waveVolume}%`, animationDelay: `${i * 0.1}s` }} />
      ))}
    </>
  );
};

export default AudioWaves;